import { render, staticRenderFns } from "./ProtocolReadOnlyBtmOption.vue?vue&type=template&id=41701670&scoped=true&"
import script from "./ProtocolReadOnlyBtmOption.vue?vue&type=script&lang=js&"
export * from "./ProtocolReadOnlyBtmOption.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolReadOnlyBtmOption.vue?vue&type=style&index=0&id=41701670&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41701670",
  null
  
)

export default component.exports